import { render, staticRenderFns } from "./ViewCardexNotes.vue?vue&type=template&id=3636d174&"
import script from "./ViewCardexNotes.vue?vue&type=script&lang=js&"
export * from "./ViewCardexNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports